import React from 'react';
import classNames from 'classnames';
import useFilterOptionsList from './UseFilterOptionsList';
import FilterOptionListRow from './FilterOptionListRow';
export default function FilterOptionsList(props) {
    const { facet, initialNumOptions, isCollapsed, isShowAll, setIsShowAll, optionsToRender, selectedOptionMap, onOptionSelect, } = useFilterOptionsList(props);
    if (optionsToRender.length === 0)
        return null;
    return (React.createElement("div", { className: classNames({
            'cio-collapsible-wrapper': true,
            'cio-collapsible-is-open': !isCollapsed,
        }) },
        React.createElement("ul", { className: 'cio-filter-multiple-options-list cio-collapsible-inner' },
            optionsToRender.map((option) => (React.createElement(FilterOptionListRow, { id: `${facet.name}-${option.value}`, key: option.value, optionValue: option.value, displayValue: option.displayName, displayCountValue: option.count.toString(), isChecked: selectedOptionMap[option.value] || false, onChange: onOptionSelect }))),
            initialNumOptions < facet.options.length && (React.createElement("button", { type: 'button', className: 'cio-see-all', onClick: () => setIsShowAll(!isShowAll) }, isShowAll ? 'Show Less' : 'Show All')))));
}
